module.exports = __webpack_public_path__ + "static/media/male.b00adf15.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/male.png
// module id = 219
// module chunks = 37